import { render, staticRenderFns } from "./DropdownV2Properties.vue?vue&type=template&id=6f4169f2&"
import script from "./DropdownV2Properties.vue?vue&type=script&lang=js&"
export * from "./DropdownV2Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports